import { gsap } from 'gsap';
import $ from 'jquery'
import { map, lerp, getMousePos, calcWinsize, getRandomNumber } from './utils';

let winsize = calcWinsize();
window.addEventListener('resize', () => winsize = calcWinsize());

let mousepos = {x: winsize.width/2, y: winsize.height/2};
window.addEventListener('mousemove', ev => mousepos = getMousePos(ev));


$('.hover--item').each(function(){
    // amounts to move in each axis
    let translationVals = {tx: 0, ty: 0};
    // get random start and end movement boundaries
    const xstart = getRandomNumber(15,60);
    const ystart = getRandomNumber(15,60);

    const containerHeight = $(this).parents('.js-hovers').outerHeight();
    const docHeight = $(document).height();
    
    // infinite loop
    const render = () => {
        // Calculate the amount to move.
        // Using linear interpolation to smooth things out. 
        // Translation values will be in the range of [-start, start] for a cursor movement from 0 to the window's width/height
        translationVals.tx = lerp(translationVals.tx, map(mousepos.x, 0, winsize.width, -xstart, xstart), 0.07);
        translationVals.ty = lerp(translationVals.ty, map(mousepos.y, 0, winsize.height, -ystart, ystart), 0.07);
        
        gsap.set($(this), {x: translationVals.tx, y: translationVals.ty});   
        requestAnimationFrame(render);
    }
    requestAnimationFrame(render);
});

gsap
    .timeline()
    .set('.hover--item', {scale: 0.7, opacity: 0}, 0)
    .to('.hover--item', {
        duration: 2,
        ease: 'Expo.easeOut',
        scale: 1,
        stagger: {amount: 0.6, from: 'center'}
    }, 0)
    .to('.hover--item', {
        duration: 3,
        ease: 'Power1.easeOut',
        opacity: 1,
        stagger: {amount: 0.6, from: 'center'}
    }, 0);